import React from "react";
import SignUp from "../features/auth/component/SignUp";
import SignUpNew from "../features/auth/component/SignUpNew";
import Footer from "./Footer";

function SignUpPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <SignUpNew></SignUpNew>
      <Footer />
    </div>
  );
}

export default SignUpPage;
